import * as S from '../add-note-form/styles';

export default S;
